import { STORAGE_KEYS } from 'utils/constants';
import { apiService } from './base.service';
import axios from 'axios';
import { CompaniesListType } from 'models/company.model';

const LOGIN_URL = 'auth/login';
const API_URL = process.env.REACT_APP_API_URL;

class AuthService {
  /** *********************************Login********************* */
  login = async (data: object) => {
    const response = await apiService.post(LOGIN_URL, { data, useToken: false });
    if (response.data) {
      const res = response.data.data;
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, res.token);
      localStorage.setItem(STORAGE_KEYS.USER_ID, res.data.id);
      localStorage.setItem(STORAGE_KEYS.EMAIL, res.data.email);
      localStorage.setItem(STORAGE_KEYS.FIRST_NAME, res.data.first_name);
      localStorage.setItem(STORAGE_KEYS.LAST_NAME, res.data.last_name);
      localStorage.setItem(STORAGE_KEYS.PHONE_NUMBER, res.data.phone_number);
      localStorage.setItem(STORAGE_KEYS.ROLE, res.data.role);
      // TODO :: make any extra API call here

      return true;
    }
  };

  forgotPassword = async (data: object) => {
    const response = await apiService.post('auth/forgot', { data, useToken: false });
    return response;
  };
  resetPassword = async (data: object) => {
    const response = await apiService.post('auth/reset', { data, useToken: false });
    return response;
  };
  confirmEmail = async (data: object) => {
    const response = await apiService.post('auth/confirm-email', { data, useToken: false });
    return response;
  };
  acceptInvitation = async (data: object) => {
    const response = await apiService.post('auth/accept-invitation', { data, useToken: false });
    return response;
  };
  createPassword = async (data: object) => {
    const response = await apiService.post('auth/password', { data, useToken: false });
    return response;
  };
  async postAuthData(url: any, data: any) {
    return axios
      .post(API_URL + url, data)

      .then((response) => response);
  }
  isCompanyVerified = async () => {
    const res = await apiService.get<{ data: CompaniesListType[] }>('company');
    return res?.data?.data?.some((c) => c?.verified);
  };
}

export default new AuthService();
